import React from 'react';

import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { RovoDebuggingPanel } from '@atlassian/rovo-debugging-panel';

import { useAssistanceServiceParams } from '../../common/utils/use-assistance-service-params';
import { useConversation } from '../../controllers/conversation/useConversation';
import { useDebugController } from '../../controllers/debug';

import { DebugModalContents } from './debug-modal-contents';

/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
const DebugModalOld = () => {
	const { isDebugModalOpen, closeDebugModal } = useDebugController();

	return (
		<ModalTransition>
			{isDebugModalOpen && (
				<Modal onClose={closeDebugModal} width="x-large">
					<ModalHeader hasCloseButton>
						<ModalTitle>
							<code>Debug Information</code>
						</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<DebugModalContents />
					</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={closeDebugModal}>
							<code>Close</code>
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};

const DebugModalNew = (): JSX.Element => {
	const { isDebugModalOpen, closeDebugModal } = useDebugController();
	const { conversation } = useConversation();
	const assistanceServiceParams = useAssistanceServiceParams({
		touchpointSource: 'debug-modal-contents',
	});

	return (
		<RovoDebuggingPanel
			isOpen={isDebugModalOpen}
			onClose={closeDebugModal}
			assistanceServiceParams={assistanceServiceParams}
			conversationId={conversation?.id}
		/>
	);
};

export const DebugModal = (): JSX.Element => {
	if (fg('graphyte_rovo_debug_enhancement')) {
		return <DebugModalNew />;
	}
	return <DebugModalOld />;
};
